import axiosInstance from "../api/axios";

/** Zumale-admin Interior Executions (ZUMALE_USER) — adoption stats + read-only pre-execution interactions. */
export const getInteriorExecutionStats = async () =>
  axiosInstance.get("/admin/interior-executions/stats");

export const getPreExecutionInteractions = async ({ status, developerId, projectId, projectPhaseId, propertyConfigId, search, page = 1, pageSize = 25 } = {}) => {
  const params = { page, pageSize };
  if (status) params.status = status;
  if (developerId) params.developerId = developerId;
  if (projectId) params.projectId = projectId;
  if (projectPhaseId) params.projectPhaseId = projectPhaseId;
  if (propertyConfigId) params.propertyConfigId = propertyConfigId;
  if (search) params.search = search;
  return axiosInstance.get("/admin/interior-executions/interactions", { params });
};

/** Cascading developer/project/phase/config options for the shared filter bar. */
export const getInteriorExecutionFilters = async () =>
  axiosInstance.get("/admin/interior-executions/filters");

/** Read-only interaction detail: the flat lead + deliverables[], adapted to the legacy
 *  {designSubmission, designIterations} wrapper shape the detail view flattens. */
export const getLeadDesignSubmissions = async (idLeadId) => {
  const lead = await axiosInstance.get(`/interior-designers/leads/${idLeadId}/detail`);
  const deliverables = (lead?.deliverables || []).map((d) => ({ ...d, iterationStatus: d.status }));
  return [
    {
      designSubmission: {
        designSubmissionId: idLeadId,
        title: lead?.title,
        description: lead?.description,
        idLead: lead,
      },
      designIterations: deliverables,
    },
  ];
};

/** All payments recorded against a lead (DESIGN_ADVANCE / DESIGN_FEE / EXECUTION_STAGE). */
export const getLeadPayments = async (idLeadId) =>
  axiosInstance.get(`/interior-designers/id-lead-payments/${idLeadId}`);
